import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
    Container,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Button,
    Card,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiCardContent from '@mui/material/CardContent';
import Footer from '../navbar/Footer';

const CardContent = styled(MuiCardContent)(`
  display: flex;
  flex-direction: row;
  padding: 16px;
`);

const pndData = [
    {
        title: "Rapport des indicateurs de suivi de la mise en œuvre de la Vision Burundi et du Plan National de Développement révisé (PND BURUNDI 2018-2027)",
        link: "/documents/IndicateursODD/Rapport_des_indicateures_mise_oeuvre_vision _Burundi_2024.pdf",
        description: "L'analyse approfondie des indicateurs de suivi de la mise en œuvre de la Vision Burundi et du Plan National de Développement révisé (PND BURUNDI 2018-2027).",
        publicationDate: "2025-12-15",
        imageLink: 'assets/indicateursODD/meta_indicateur_Vision20240_20260_revise.PNG',
    },
    {
        title: "Métadonnées des indicateurs de la vision : Burundi pays émergent en 2040 et pays développé en 2060",
        link: "/documents/IndicateursODD/Metadonnees_Vision_PND_Revise_Final.pdf",
        description: "L'analyse détaillée des métadonnées relatives aux indicateurs qui soutiennent la vision du Burundi en tant que pays émergent d'ici 2040 et développé d'ici 2060.",
        publicationDate: "2022-05-15",
        imageLink: 'assets/indicateursODD/meta_indicateur_Vision20240_20260_revise.PNG',
    },
    {
        title: "Rapport d'actualisation des indicateurs de suivi de la mise en œuvre du Plan National de Développement (PND) du Burundi 2018-2027, édition 2021",
        link: "/documents/IndicateursODD/Rapport-dactualisation-des-indicateurs-de-suivi-de-la-mise-en-oeuvre-du-PNDEdition-2021.pdf",
        description: "",
        publicationDate: "2021-12-20",
        imageLink: 'assets/indicateursODD/rapport_actualisation_indicateurpnd_2021.PNG',
    },
    {
        title: "Rapport d'actualisation des indicateurs du Plan National de Développement (PND) du Burundi",
        link: "/documents/IndicateursODD/Rapport_PND-2022-2.pdf",
        description: "",
        publicationDate: "2022-09-10",
        imageLink: 'assets/indicateursODD/rapport_PND_2023.PNG',
    },
];

const PNDIndicators = () => {
    const [visibleCount, setVisibleCount] = useState(2);
    const [filterYear, setFilterYear] = useState('all');

    const getYear = (dateString) => new Date(dateString).getFullYear();

    const filteredData = filterYear === 'all'
        ? pndData
        : pndData.filter(item => getYear(item.publicationDate) === parseInt(filterYear, 10));

    const years = [...new Set(pndData.map(item => getYear(item.publicationDate)))];
    years.sort((a, b) => b - a);

    const handleLoadMore = () => {
        setVisibleCount(prev => prev + 2);
    };

    const handleFilterChange = (event) => {
        setFilterYear(event.target.value);
        setVisibleCount(2);
    };

    const cardStyle = {
        marginBottom: '10px',
        border: '1px solid #ddd',
        borderRadius: '5px',
    };

    const imageStyle = {
        width: '80px',
        height: 'auto',
        marginRight: '20px',
        borderRadius: '5px',
        display: 'block',
    };

    const contentStyle = {
        flex: '1',
    };

    const menuItemStyle = {
        color: 'green',
    };

    return (
        <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '10px' }}>
            <NavigationBar />
            <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
                <Typography variant="h6" align="justify" gutterBottom>
                    Le Plan National de Développement (PND)
                </Typography>
                <Typography variant="body1" align="justify" paragraph>
                    Cette section explore les rapports et documents liés au Plan National de Développement (PND) du Burundi.
                    Le rapport sur les Indicateurs du PND constitue un outil crucial de planification stratégique, visant à guider
                    le Burundi vers son émergence d'ici 2027. Baptisé "Plan National de Développement 2018-2027", il aborde l'ensemble
                    des défis de développement auxquels le pays fera face au cours des dix prochaines années. Ce projet ambitieux met
                    l'accent sur la nécessité d'une synergie entre les enjeux environnementaux, sociaux et économiques, qui doivent
                    être considérés de manière intégrée, en adoptant de nouveaux modèles économiques et des modes de vie innovants.
                </Typography>

                <FormControl fullWidth margin="normal" style={{ marginLeft: '0px', width: '300px' }}>
                    <InputLabel id="year-filter-pnd-label">Sélectionnez par l'année de publication (PND)</InputLabel>
                    <Select
                        labelId="year-filter-pnd-label"
                        id="year-filter-pnd"
                        value={filterYear}
                        label="Sélectionnez par l'année de publication (PND)"
                        onChange={handleFilterChange}
                    >
                        <MenuItem value="all">Tous les indicateurs (PND)</MenuItem>
                        {years.map(year => (
                            <MenuItem key={year} value={year} style={menuItemStyle}>{year}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {filteredData.slice(0, visibleCount).map((document, index) => (
                    <Card key={index} style={cardStyle}>
                        <CardContent>
                            <a href={document.link} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'flex-start', textDecoration: 'none', color: 'inherit' }}>
                                <Box>
                                    <img src={document.imageLink} alt={document.title} style={imageStyle} />
                                </Box>
                            </a>
                            <Box style={contentStyle}>
                                <a href={document.link} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'flex-start', textDecoration: 'none', color: 'inherit' }}>
                                    <Typography variant="h6" component="div" style={{ color: 'green' }}>
                                        <DownloadIcon /> {document.title}
                                    </Typography>
                                </a>
                                <Typography variant="body2" color="textSecondary">
                                    {document.description}
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                ))}

                {visibleCount < filteredData.length && (
                    <Button
                        onClick={handleLoadMore}
                        style={{
                            marginTop: '20px',
                            backgroundColor: '#388E3C',
                            color: 'white',
                        }}
                    >
                        Plus d'indicateurs (PND)
                    </Button>
                )}
            </Container>
            <br />
            <br />
            <Footer />
        </div>
    );
};

export default PNDIndicators;